import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable'
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModaldal';
import { Grid } from '@mui/material';
// import BannerinputGetModal from '../../../CommonModal/BannerModal/BannerinputGetModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import '../../../../Components/ModalCss/BannerinputGetModal.css';
// import LandingPage from '../../Preview/LandingPage';
import PreviewComponent from '../../PreviewComponent/PreviewComponent';
import StakeNowMainPage from '../StakeNowPreview/Banner/StakeNowMainPage';
import BannerinputGetModal from '../Modal/Banner/BannerinputGetModal';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';

const BannerSection = () => {

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    const role = sessionStorage.getItem("role")
    // csonole

    // const tableData = role === "superAdmin"
    //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
    //   : [];

    const tableHeadData = role === "superAdmin" || role === "management"
        ? ['S.No', 'Title', 'Second Text', 'Sub Text', 'Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role", "status"]
        : ['S.No', 'Title', 'Second Text', 'Sub Text', 'status']





    const dispatch = useDispatch();

    const [responseTableData, setResponseTableData] = useState([])
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    console.log(responseTableData, "responseTableDataresponseTableData")
    const { getStakeNowSectionById } = useSelector(state => state?.getStakeNowSectionById);
    const { addStakeNowSectionPost } = useSelector(state => state?.addStakeNowSectionPost);

    const { updateStakeNowSection } = useSelector(
        (state) => state?.updateStakeNowSection
    );

    const { deleteStakeNowSection } = useSelector(
        (state) => state?.deleteStakeNowSection
    );




    const { getAllStakeNowSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllStakeNowSectionsWithCreatorBySectionName
    );

    const { getAllStakeNowSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllStakeNowSectionsBySectionNameBasedOnCreator
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllStakeNowSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addStakeNowSectionWithApproval } = useSelector(
        (state) => state?.addStakeNowSectionWithApproval
    );




    const { updateStakeNowSectionForReApproval } = useSelector(
        (state) => state?.updateStakeNowSectionForReApproval
    );



    const { approveStakeNowSection } = useSelector((state) => state?.approveStakeNowSection);
    const { rejectStakeNowSection } = useSelector((state) => state?.rejectStakeNowSection);


    useEffect(() => {
        const fetchData = async () => {
            if (role === "superAdmin" || role === "management") {

                const data1 = {
                    data: {

                        section_name: "banner" // "Touch" , "getInTouch"
                    },
                    method: "post",
                    apiName: `getAllStakeNowSectionsBySectionNameWithAllAuthUserDetails`,
                };

                const responseData = await dispatch(actions.GETALLSTAKENOWSECTIONSWITHCREATORBYSECTIONNAME(data1));
                setResponseTableData(responseData?.payload)

            }

            else {

                const data1 = {
                    data: {
                        section_name: "banner" // "Touch" , "getInTouch"

                    },
                    method: "post",
                    apiName: `getAllStakeNowSectionsBySectionNameBasedOnCreator`,
                };

                const responseData = await dispatch(actions.GETALLSTAKENOWSECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
                setResponseTableData(responseData?.payload)


            }
        }


        fetchData();
    }, [addStakeNowSectionPost, approveStakeNowSection, rejectStakeNowSection, addStakeNowSectionWithApproval, deleteStakeNowSection, updateStakeNowSection, updateStakeNowSectionForReApproval]);

    useEffect(() => {
        const tempArr = [];
        if (role === "superAdmin" || role === "management") {
            getAllStakeNowSectionsWithCreatorBySectionName?.data?.map((data, index) => {
                return tempArr.push({
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',

                    title: data?.heading || '--',
                    secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',
                    approverName: data?.approver?.name || '--',
                    approverRole: data?.approverRole?.roleName || '--',
                    rejectorName: data?.rejector?.name || '--',
                    rejectorRole: data?.rejectorRole?.roleName || '--',
                    // approval_status: data?.approval_status || "--"
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"
                });
            });
            setRowTableData(tempArr);
        } else {
            getAllStakeNowSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"

                });
            });
            setRowTableData(tempArr);

        }
    }, [getAllStakeNowSectionsBySectionNameBasedOnCreator, getAllStakeNowSectionsWithCreatorBySectionName]);


    console.log(rowTableData, "rowTableDatattattata")


    const handleTableDataDelete = async (id) => {


        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteStakeNowSection/${id}`,
        };
        const responseData = await dispatch(actions.DELETESTAKENOWSECTION(data1));
        if (responseData?.payload?.message === "Stake Now section soft deleted successfully.") {
            toast.success(responseData?.payload?.message)
        } else {
            toast.error(responseData?.payload?.message)

        }
    }


    React.useEffect(() => {
        dispatch(setHeaderName("Content Management"));
        dispatch(setSubHeaderName("Stake Now"));
    }, []);


    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>

                <CustomTable
                    // tableEdit="tableEdit"
                    // tableDelete="tableDelete"

                    tableData={rowTableData} title="Banner" tableHeadData={tableHeadData}
                    //   modalName={BannerinputGetModal}
                    //   editModalName={BannerinputGetModal}


                    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
                    tableView={true}
                    modalVeiwName={PreviewComponent}
                    ModalPreviewComponent1={StakeNowMainPage}

                    handleTableDataDelete={handleTableDataDelete}

                    sectionNameForApproveAndReject="StakeNowSection"
                    tableDelete={permissions?.ContentManagement?.["Stake Now"]?.delete}
                    tableEdit={permissions?.ContentManagement?.["Stake Now"]?.edit}
                    dataCreate={permissions?.ContentManagement?.["Stake Now"]?.add}
                    //   apiBasedName="stakeNowBannerInputModal"
                    //   tableData={rowTableData}
                    //   title="Banner"
                    //   tableHeadData={tableHeadData}
                    modalName={BannerinputGetModal}
                    editModalName={BannerinputGetModal}
                //   handleTableDataDelete={handleTableDataDelete}

                />

            </Grid>
        </Grid>
    )
}

export default BannerSection